import { useState, useEffect, useCallback, useRef } from "react";


export const useDebounceSetStateAsync = (delay = 200) => {

    const timeoutRef = useRef("");
    const isMountedRef = useRef(true);

    useEffect(() => {
        return () => {
            if (isMountedRef.current = false) {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            }
        }
    }, [])

    const debounceSetStateAsync = useCallback((callback) => {

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        } 
         timeoutRef.current = setTimeout(() => {
                if (isMountedRef.current) {
                    callback();
                }
            }, delay)
    
    }, [delay])


    return debounceSetStateAsync;

}